import { render, staticRenderFns } from "./test1.vue?vue&type=template&id=68be6a86&scoped=true&"
import script from "./test1.vue?vue&type=script&lang=js&"
export * from "./test1.vue?vue&type=script&lang=js&"
import style0 from "./test1.vue?vue&type=style&index=0&id=68be6a86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be6a86",
  null
  
)

export default component.exports